/** Company presentation only. Runtime identifiers and API contracts stay stable. */
export const COMPANY_BRAND = {
  name: '阿宝姐',
  productName: '阿宝姐 · 创作工作台',
  avatar: '/brand/abao-avatar.png',
  website: 'https://abao-ai.com',
} as const;
